<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">新建订单</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body" style="height: 400px;">
                <el-row>
                    <el-card class="box-card" shadow="never">
                        <div slot="header" class="clearfix">
                            <i class="el-icon-user" style="margin-right:5px"></i><span>下单人</span>
                        </div>
                        <el-col :span="24">
                            <el-form :model="searchElForm" :rules="searchElRules" inline ref="searchElForm">
                                <el-form-item prop="name">
                                    <el-input  placeholder="请输入姓名" v-model.trim="searchElForm.name" clearable></el-input>
                                </el-form-item>
                                <el-form-item prop="phone">
                                    <el-input  placeholder="请输入手机号" v-model.trim="searchElForm.phone" maxlength="11" clearable></el-input>
                                </el-form-item>
                                <el-button  type="primary" icon="el-icon-search" @click="getElderly">查询</el-button>
                            </el-form>
                            <el-table
                                :data="elderlyInfo"
                                style="width: 100%" border stripe max-height='450'>
                                <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                                <el-table-column label="手机号" prop="phone"></el-table-column>
                                <el-table-column prop="createTime" :formatter="getTime" label="注册时间" ></el-table-column>
                                <el-table-column prop="userStatus" :formatter="userStatus" label="状态" ></el-table-column>
                            </el-table>
                        </el-col>
                    </el-card>
                    <el-card class="box-card" shadow="never">
                        <div slot="header" class="clearfix">
                            <i class="el-icon-shopping-bag-1" style="margin-right:5px"></i><span>关联商品</span>
                            <el-button  type="text" style="float: right; padding: 3px 0" icon="el-icon-circle-plus-outline" @click="getGoods">添加商品</el-button>
                        </div>
                        <el-col :span="24">
                            <el-table
                                :data="goodsData"
                                style="width: 100%" border stripe max-height='450'>
                                <el-table-column prop="name" label="标题" min-width="130" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="nameMore" label="副标题" min-width="200" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="goodsPriceDTOList[0].price" label="单价（元）" width="100"></el-table-column>
                                <el-table-column
                                    min-width="140"
                                    prop="number"
                                    label="数量">
                                    <template slot-scope="item">
                                        <el-input-number size="small" :precision='0' :min="0" v-model.trim="item.row.number"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                min-width="200"
                                    prop="planTime"
                                    label="预约时间">
                                    <template slot-scope="item">
                                        <el-date-picker
                                            v-if="item.row.planTime"
                                            v-model="item.row.planTime"
                                            type="datetime"
                                            :clearable="false"
                                            placeholder="请选择预约时间"
                                            :default-value="new Date()"
                                            :picker-options="pickerOptions0"
                                            value-format="yyyy-MM-dd HH:mm"
                                            style="width:100%">
                                        </el-date-picker>
                                        <span v-else style="color:#909399">普通商品无预约时间</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" fixed="right" width="100">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="small" @click.native.prevent="handleDelete(scope.$index, goodsData)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-card>
                    <el-card class="box-card" shadow="never" :body-style="cardBodyStyle">
                        <div slot="header" class="clearfix">
                            <i class="el-icon-position" style="margin-right:5px"></i><span>收货地址</span>
                        </div>
                        <el-table
                            :data="addressInfo"
                            style="width: 100%;" border stripe max-height='450' v-if="addressInfo.length>0">
                            <el-table-column prop="receiveName" label="名称" width="150"></el-table-column>
                            <el-table-column prop="receivePhone" label="手机号"></el-table-column>
                            <el-table-column prop="areaNamePath" label="地区"></el-table-column>
                            <el-table-column prop="receiveAddress" width="200" label="详细地址"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click="showAddress(scope.$index, scope.row)">更换</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button type="primary" v-if="addressInfo.length==0" style="width:30%;margin-bottom:20px;" @click="showAddress">选择地址</el-button>
                    </el-card>
                </el-row>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm()">提交</el-button>
            </div>
        </div>
        <el-dialog title="老人列表" :visible.sync="elderlyTableShow" :modal-append-to-body='false' :close-on-click-modal='false'>
            <el-table ref="elderlyTable" :data="elderlyTable" border height="200px">
                <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <el-table-column prop="createTime" :formatter="getTime" label="注册时间" ></el-table-column>
                <el-table-column prop="userStatus" :formatter="userStatus" label="状态" ></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" size="medium" @click.native.prevent="elderlyAdd(scope.row)">选定</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

      <Address ref="myAddress" v-show="showModalAddress" v-on:closeAddress="closeAddress" v-on:setAddress="setAddress"></Address>
      <GetGoods ref="myGetGoods" v-show="showModalGetGoods" v-on:closeGetGoods="closeGetGoods" v-bind:goodsClassGovValue="goodsClassGovValue" v-on:selectionChange="selectionChange"></GetGoods>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    // import CartEdit from "./CartEdit"
    import Address from "./Address"
    import GetGoods from "./GetGood"

    export default {
        name: 'Cart',
        data() {
            return {
                goodsTableShow:false,
                elderlyTableShow:false,
                showModalGetGoods:false,
                showModalAddress:false,
                loading: false,
                cartInfo:[],
                elderlyTable:[],
                goodsTable:[],
                cardBodyStyle:{'text-align':'center'},
                addressInfo:[],
                imgUrl:this.$imgUrl,
                elderly:'',
                userAddressCode:'',
                totalItems:0,
                elderlyCode:'',
                searchElForm:{
                    name:'',
                    phone:'',
                },
                elderlyInfo:[],
                searchElRules:{
                    phone:[
                        { required: false, pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
                    ]
                },
                goodsSelection:[],
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                goodsData:[]
            }
        },
        components:{Address,
        GetGoods
        },
        methods: {
            init(){
                this.addressInfo=[]
                this.goodsSelection=[]
                this.goodsData=[]
                this.userAddressCode=""
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClassGovernment/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error === 0) {
                            this.goodsClassGovValue = response.data.data;
                        }else if(response.data.error === 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            closeSelf() {
                this.$emit("closeCart");
            },
            elderlyAdd(row){
                this.elderlyInfo=[row]
                this.elderlyCode=row.elderlyCode
                this.elderlyTableShow=false
            },
            //商品添加回显
            selectionChange(val){
                this.goodsSelection=val
                this.goodsData=this.getGoodsData(val)
            },
            //商品添加回显数据处理
            getGoodsData(val){
                var list=[]
                val.forEach(element => {
                    var element1=null
                    if(this.goodsData.length>0){
                        this.goodsData.forEach(element2 => {
                            if(element2.goodsCode==element.goodsCode){
                                element1={planTime:element2.planTime,number:element2.number}
                            }
                        })
                    }
                    if(!element1){
                        element1={planTime:timefilters(new Date()),number:1}
                    }
                    Object.assign(element1,element)
                    list.push(element1)
                });
                return list
            },
            //商品添加
            getGoods(){
                this.$refs.myGetGoods.init(this.goodsData)
                this.showModalGetGoods=true
            },
            //商品删除
            handleDelete(index, rows){
                this.$confirm('此操作将删除此商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    rows.splice(index, 1);
                    this.goodsSelection.splice(index, 1);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            showAddress(){
                if(!this.elderlyCode){
                    this.$message.error('请选择老人')
                    return
                }
                this.$refs.myAddress.init(this.elderlyCode);
                this.closeAddress()
            },
            setAddress(address){
                this.addressInfo=[]
                this.addressInfo.push(address);
                this.userAddressCode=address.userAddressCode
            },

            //提交
            confirm(){
                if(this.goodsData.length==0){
                    this.$message.error('请添加商品')
                    return
                }
                if(!this.userAddressCode){
                    this.$message.error('请选择收货地址')
                    return
                }
                var data={
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    timeStr:timeStr,
                    staffCode:getStaffCode(),
                    userAddressCode:this.userAddressCode,
                    elderlyCode:this.elderlyCode
                }
                Object.assign(data,this.getSubmitData())
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/CallSubmit",
                    data: data
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.closeSelf();
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },

            //提交数据处理
            getSubmitData(){
                var totalPrice=0
                var goodsList=[]
                this.goodsData.forEach(element => {
                    totalPrice+=element.goodsPriceDTOList[0].price*element.number
                    if(element.goodsType==2){
                        goodsList.push(this.getGoodsListData(element))
                    }else{
                        var goodsInfo=null
                        goodsList.forEach(element1=>{
                            if(element1.goodsType==1&&element.businessCode==element1.businessCode){
                                element1.price+=element.goodsPriceDTOList[0].price*element.number
                                goodsInfo={
                                    goodsCode:element.goodsCode,
                                    number:element.number,
                                    planTime:element.planTime,
                                    goodsPriceCode:element.goodsPriceDTOList[0].goodsPriceCode,
                                }
                                element1.goodsInfoList.push(goodsInfo)
                            }
                        })
                        if(!goodsInfo){
                            goodsList.push(this.getGoodsListData(element))
                        }
                    }
                });
                return {totalPrice:totalPrice,goodsList:goodsList}
            },
            getGoodsListData(element){
                var data={
                        businessCode:element.businessCode,
                        price:element.goodsPriceDTOList[0].price*element.number,
                        goodsType:element.goodsType,
                        planTime:element.planTime,
                        goodsInfoList:[{
                            goodsCode:element.goodsCode,
                            number:element.number,
                            planTime:element.planTime,
                            goodsPriceCode:element.goodsPriceDTOList[0].goodsPriceCode,
                        }]
                    }
                return data
            },
            closeGetGoods:function(){
                this.showModalGetGoods = !this.showModalGetGoods;
            },
            closeAddress:function(){
                this.showModalAddress = !this.showModalAddress;
            },
            getTime(row,index,column){
                return timefilters(column)
            },
            userStatus(row) {
                if (row.userStatus == 1) {
                    return "正常";
                }
                if (row.userStatus == 2) {
                    return "禁用";
                }
                return "其它";
            },
            getElderly(){
                this.$refs.searchElForm.validate((valid) => {
                    if(valid){
                        if(!this.searchElForm.name&&!this.searchElForm.phone){
                            this.$message.error('请输入筛选项')
                            return
                        }
                        var data={
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            status:-1,
                            pageIndex:1,
                            pageSize:30
                        }
                        Object.assign(data,this.searchElForm)
                        this.$axios({
                            method: 'post',
                            url: this.$shopUrl+"Elderly/PageForGovernmentCode",
                            data:data
                        }).then(
                            (response) => {
                                if (response.data.error == 0) {
                                    this.elderlyTable=response.data.data.list;
                                    this.elderlyTableShow=true
                                }else if(response.data.error == 1){
                                    this.$message.error(response.data.message)
                                }
                            }
                        )
                    }else {
                        return false;
                    }
                })

            },

        }
    }


</script>
<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1000px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body .box-card{
                margin-bottom:20px;
                border-bottom: none;
            }
            .modal-body {
                position: relative;
                padding: 20px;
                z-index: 99;
                overflow-y:auto;
                height:670px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px 40px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
